module.exports = __webpack_public_path__ + "img/wallpaper-do-your-part-eat-smart.ecb0eb49.png";